import { importWithVersionCheck, Locale } from '@libs/typescript-utils'

export async function getLocale(locale: Locale): Promise<Record<string, string>> {
  // Import specifiers must be literal strings for Vite to resolve them statically.
  if (locale === 'en') {
    return (await importWithVersionCheck(() => import('./en.json'))).default
  } else {
    return (await importWithVersionCheck(() => import('./hu.json'))).default
  }
}
